module.exports = __webpack_public_path__ + "static/media/RecomendaPetropolis.37946df9.jpg";